import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Overview of ChatGPT applications" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">ChatGPT toepassingen</h2>

        <div className="space-y-4">
          <p>• Samenvatten</p>
          <p>• Vertalen</p>
          <p>• Teksten verder uitwerken</p>
          <p>• Moeilijke concepten uitleggen (ELI5)</p>
          <p>• Informatie vragen</p>
          <p>• Code schrijven, en runnen</p>
          <p>• Afbeeldingen genereren</p>
          <p>• Afbeeldingen analyseren</p>
          <p>• Diverse bestanden bewerken</p>
        </div>
      </div>
    </Slide>
  );
};
